import { useTranslation } from "react-i18next";
import { Globe, Check } from "lucide-react";
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import { SUPPORTED_LANGS } from "../../i18n";

export const LanguageSwitcher = ({ variant = "light" }) => {
    const { i18n } = useTranslation();
    const current =
        SUPPORTED_LANGS.find((l) => l.code === i18n.language) ||
        SUPPORTED_LANGS[0];

    const change = (code) => {
        i18n.changeLanguage(code);
    };

    const triggerClass =
        variant === "dark"
            ? "bg-white/10 hover:bg-white/20 text-white"
            : "bg-white/80 hover:bg-white border border-stone-200 text-stone-800";

    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button
                    type="button"
                    data-testid="language-switcher"
                    className={`inline-flex items-center gap-2 rounded-full px-3 py-2 text-sm font-medium transition-colors ${triggerClass}`}
                >
                    <Globe className="h-4 w-4" />
                    <span className="hidden sm:inline">{current.label}</span>
                    <span className="sm:hidden">{current.flag}</span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent
                align="end"
                className="min-w-[180px] rounded-xl"
            >
                {SUPPORTED_LANGS.map((l) => (
                    <DropdownMenuItem
                        key={l.code}
                        data-testid={`language-option-${l.code}`}
                        onClick={() => change(l.code)}
                        className="flex items-center justify-between gap-3 cursor-pointer"
                    >
                        <span className="flex items-center gap-2">
                            <span className="text-base">{l.flag}</span>
                            <span>{l.label}</span>
                        </span>
                        {l.code === current.code && (
                            <Check className="h-4 w-4 text-orange-500" />
                        )}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
};
